
export const routes = {
  ROOT: '/',
  SIGN_IN: '/sign-in',
  RECOVER_PASSWORD: '/recover-password',
  RESET_PASSWORD: '/reset-password',
  SALES_REPORTS: '/sales-reports',
  SALES_DETAILS: '/sales-reports/:id',
  FINANCIAL_AGENDA: '/financial-agenda',
  DASHBOARD: '/dashboard',
  ALL_REPORTS: '/reports',
  CHANGE_PASSWORD: '/change-password',
  FINANCES: '/finances',
  USERS_MANAGEMENT: '/users-management',
  SUBSELLERS: '/subsellers',
  SCHEDULES: '/schedules',
  PAYMENT_BATCHES: '/payment-orders/batches',
  PAYMENT_BATCH_ORDERS: '/payment-orders/batches/:id/orders',
  SELLERS_BALANCES: '/sellers/balance',
  SIM_BANK: '/sim/bank',
  PAYMENTPLAN: '/payment-plan',
  READPLAN: '/payment-plan/:id',
  RECONCILIATION: '/reconciliation',
  DETAILSRECONCILIATION: '/reconciliation/:id',
  PIX_KEY: '/pix/:id',
  PLAN_WEBHOOK_DETAILS: '/payment-plan/webhook/:id',
  SUPPORT: '/support',
  HOME: '/home',
  SUMMARY: '/summary',
  FAQ: '/faq'
}
